import FormSessionBasicDetailPanel from "./FormSessionBasicDetailPanel";
import {useEffect, useState} from "react";
import {FormSessionDto} from "../../client/formsession/FormSessionApiClient";
import {useClientLocator} from "../../client/ApiClientLocator";
import {useSnackbar} from "@dain/mui-components"
import {useTranslation} from "react-i18next";
import {CommonTranslKey} from "../../common/CommonTranslKey";
import {FormSessionTranslKey} from "./FormSessionTranslKey";
import {findFormSessionById, RowId} from "./FormSessionId";
import Modal from "../../common/modal/Modal";
import TabNav from "../../common/tab/TabNav";
import Skeleton from "../../common/skeleton/Skeleton";

export interface FormSessionDetailDialogProps {
    open: boolean;
    onClose: (updated: boolean) => void;
    formSessionId?: RowId;
}

export default function FormSessionDetailDialog(props: Readonly<FormSessionDetailDialogProps>) {
    const {open, onClose, formSessionId} = props;

    const {formSessionClient} = useClientLocator();
    const snackbar = useSnackbar();
    const {t} = useTranslation();

    const [formSession, setFormSession] = useState<FormSessionDto>();
    const [refresh] = useState(Date.now());
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        if (open && formSessionId) {
            findFormSessionById(formSessionId)
                .then((formSession) => {
                    setFormSession(formSession);
                })
                .catch((error) => snackbar.error(t(CommonTranslKey.UNEXPECTED_ERROR), error));
        }
        if (!open) {
            setFormSession(undefined);
            setUpdated(false);
        }
    }, [open, formSessionId, formSessionClient, snackbar, refresh, t]);


    let basicDetailPanelContent: React.JSX.Element;
    if (formSession) {
        basicDetailPanelContent = (
            <FormSessionBasicDetailPanel formSession={formSession}/>
        );
    } else {
        basicDetailPanelContent = (
            <Skeleton count={6}/>
        );
    }
    const basicDetailPanelTabItem = {
        label: t(FormSessionTranslKey.DETAILS),
        content: basicDetailPanelContent
    };
    const tabItems = [basicDetailPanelTabItem];

    const iconProps = {
        type: "complex",
        name: "doc-basic-info",
    };

    return (
        <Modal open={open}
               label={t(FormSessionTranslKey.FORM_SESSIONS_OVERVIEW)}
               iconProps={iconProps}
               onClose={() => onClose(updated)}
        >
            <TabNav items={tabItems}/>
        </Modal>
    );
}
